import { Stack } from '@mui/material';
import dayjs from 'dayjs';

import { DATE_TIME_CALC_FORMAT } from '@/constants/date.constants';
import useStyles from '@/pages/Administration/AdministrationGeneral/AdministrationGeneral.styles';

const BasicTicketTemplate = () => {
  const { classes } = useStyles();

  return (
    <Stack className={classes.newTicketTemplate}>
      <div className={classes.newTicketTemplateItem}>
        <b>Title:</b> Example Ticket
      </div>
      <div className={classes.newTicketTemplateItem}>
        <b>Timestamp:</b> {dayjs().format(DATE_TIME_CALC_FORMAT)} UTC
      </div>
      <div className={classes.newTicketTemplateItem}>
        <b>Priority:</b> P3
      </div>
      <div className={classes.newTicketTemplateItem}>
        <b>Category:</b> Malware
      </div>
      <div className={classes.newTicketTemplateItem}>
        <b>Link:</b>{' '}
        <a
          className={classes.linkText}
          target="_blank"
          rel="noreferrer"
          href="https://scope.pondurance.com/"
        >
          A link to the ticket
        </a>
      </div>
    </Stack>
  );
};

export default BasicTicketTemplate;
